import React from "react";
import { TicketsList } from "./list/tickets-list";
import "./style.scss";

export default function CustomerServicePortal() {
  return <TicketsList />;
}
